import Cookies from 'js-cookie'

function getCookie(name, cookie?: string) {
  // 获取cookies
  let strCookie = cookie || ''
  if (!process.server) {
    strCookie = document.cookie
  }
  const arrCookie = strCookie.split('; ')
  for (let i = 0; i < arrCookie.length; i++) {
    const arr = arrCookie[i].split('=')
    if (name == arr[0]) {
      return arr[1]
    }
  }
  return ''
}

export function getUserId(req?: any) {
  let duToken = ''
  if (process.server && req) {
    duToken = getCookie('duToken', req.headers.cookie)
  } else {
    duToken = Cookies.get('duToken') || ''
  }
  return duToken.split('|')?.[1] || ''
}
